import { createIcon } from '@chakra-ui/react';

export const HomeIcon = createIcon({
  displayName: 'HomeIcon',
  viewBox: '0 0 576 512',
  path: (
    <path
      fill="currentColor"
      d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
    />
  ),
});

export const ShareIcon = createIcon({
  displayName: 'ShareIcon',
  viewBox: '0 0 576 512',
  path: (
    <path
      fill="currentColor"
      d="M352 224H305.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3V416c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V366.3c0-8.3 6-15.6 12.8-20.3c8.9-6.2 19.2-18.2 19.2-40.5c0-45-36.5-81.5-81.5-81.5H96c-53 0-96 43-96 96V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-53-43-96-96-96zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H96zm352 96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h32c53 0 96 43 96 96c0 35.3 28.7 64 64 64h64c35.3 0 64-28.7 64-64c0-53 43-96 96-96h32c17.7 0 32 14.3 32 32V416z"
    />
  ),
});

export const PlusIcon = createIcon({
  displayName: 'PlusIcon',
  viewBox: '0 0 448 512',
  path: (
    <path
      fill="currentColor"
      d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"
    />
  ),
});

export const CheckIcon = createIcon({
  displayName: 'CheckIcon',
  viewBox: '0 0 448 512',
  path: (
    <path
      fill="currentColor"
      d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
    />
  ),
});

export const CarIcon = createIcon({
  displayName: 'CarIcon',
  viewBox: '0 0 512 512',
  path: (
    <path
      fill="currentColor"
      d="M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    />
  ),
});

export const CameraIcon = createIcon({
  displayName: 'CameraIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M4 4h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2zm14 9a6 6 0 11-12 0 6 6 0 0112 0z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});

export const SaveIcon = createIcon({
  displayName: 'SaveIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
      fill="currentColor"
    />
  ),
});

export const HistoryIcon = createIcon({
  displayName: 'HistoryIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89.07.14L9 12H6a7 7 0 0 1 7-7 7 7 0 0 1 7 7 7 7 0 0 1-7 7v2a9 9 0 0 0 9-9zM12 8v5l4.25 2.52.75-1.23-3.5-2.07V8z"
      fill="currentColor"
    />
  ),
});

export const FAQIcon = createIcon({
  displayName: 'FAQIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
      fill="currentColor"
    />
  ),
});

export const UserIcon = createIcon({
  displayName: 'UserIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
      fill="currentColor"
    />
  ),
}); 